import { IDeliveryStatusDashboard } from "interfaces"

export const initialState: IDeliveryStatusDashboard = {
  deliveryStatusList: {
    data: [],
    isLoading: false,
  },
  deliveryStatusDetails: {
    data: [],
    isLoading: false,
  },
};
